import { where } from "firebase/firestore";
import { BaseApi } from "../user/BaseApi";

class DaoTrangApi extends BaseApi {
  constructor() {
    super("daoTrangs");
    this.defaultEntity = {
      name: "",
      description: "",
      maDaoTrang: "",
      members: [],
      fbbdh: "",
      owner: "",
      dsBan: [], // ['BLĐ','BQC', ...]
    };
  }

  async getAllDaoTrangs(ownerId) {
    return await this.query(where("owner", "==", ownerId));
  }
}

const daoTrangApi = new DaoTrangApi();

export const getDaoTrang = (id) => daoTrangApi.getOne(id);
export const getAllDaoTrangs = () => daoTrangApi.getAll();
export const createDaoTrang = (daoTrang) => daoTrangApi.create(daoTrang);
export const updateDaoTrang = (id, changes) => daoTrangApi.update(id, changes);
export const saveDaoTrang = (daoTrang) => daoTrangApi.save(daoTrang);
export const removeDaoTrang = (id) => daoTrangApi.remove(id);
export const saveOrCreateDaoTrang = (id) => daoTrangApi.saveOrCreate(id);
export const newDefaultDaoTrang = () => ({...daoTrangApi.defaultEntity});
